<template>
  <Animated name="pulse" appear duration="1200">
    <div class="">
      <sequential-entrance fromTop>
        <SellerHeader to="/seller/" :headerText="eventName" />
      </sequential-entrance>
      <!-- skeleton -->
      <div v-if="loading" class="px-5 py-5" style="width: 90%; margin: 0 auto;">
        <div class="skeleton-box skeleton-subtitle mb-6"></div>
        <div class="skeleton-box skeleton-link mb-8"></div>
        <div class="skeleton-box skeleton-subtitle mb-4"></div>
        <div class="skeleton-box skeleton-message mb-8"></div>
        <v-row justify="center" class="mt-0 pt-0 mb-5 px-4">
          <v-col cols="4" class="d-flex justify-center p-1">
            <div class="skeleton-box skeleton-btn"></div>
          </v-col>
          <v-col cols="4" class="d-flex justify-center p-1">
            <div class="skeleton-box skeleton-btn"></div>
          </v-col>
          <v-col cols="4" class="d-flex justify-center p-1">
            <div class="skeleton-box skeleton-btn"></div>
          </v-col>
        </v-row>
      </div>

      <div v-else class="py-5">
        <p class="font-weight-bolder mb-4 pt-2 px-5">
          Tu link para compartir
        </p>
        <!-- Share link -->
        <v-row class="d-flex align-center justify-center px-5 mb-6">
          <v-col cols="12">
            <div class="share-link-box d-flex align-center justify-space-between px-4 py-3">
              <a class="link-text" :href="textToCopy" target="_blank" rel="noopener">
                {{ textToCopy }}
              </a>
              <v-btn class="copy-link-btn" @click="copyLink" depressed rounded>
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <p class="font-weight-bolder mb-4 px-5">
          Difunde el evento:
        </p>

        <!-- Carrousel Mensajes -->
        <v-carousel v-model="selectedMessageIndex" hide-delimiter-background hide-delimiters height="232" show-arrows
          class="mb-1">
          <v-carousel-item v-for="(message, index) in shareMessages" :key="'msg-' + index">
            <v-card class="mx-auto pt-2 pb-3 elevation-0" max-width="100%">
              <v-card class="py-2 px-6" rounded="lg" flat>
                <v-card-text class="px-8 message-content">
                  <p class="font-weight-bold mb-2" style="color: #1D3557;">Opción {{ index + 1 }}</p>
                  <div style="white-space: pre-line; color: #333333; word-break: break-word;">
                    {{ replaceLink(message) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-card>
          </v-carousel-item>
        </v-carousel>
        <!-- Share buttons section -->
        <v-row justify="center" class="mt-3 pt-0 mt-4 mb-5 pb-5 px-5">
          <!-- Copy Button -->
          <v-col cols="4" class="d-flex justify-center pl-2 p-1">
            <v-btn class="share-btn text-none" outlined rounded large @click="copyMessage">
              <span>
                <v-icon left color="black">mdi-content-copy</v-icon>
                Copiar
              </span>
            </v-btn>
          </v-col>
          <!-- Whatsapp Button -->
          <v-col cols="4" class="d-flex justify-center p-1 ">
            <v-btn class="share-btn text-none" outlined rounded large @click="shareViaWhatsApp">
              <span>
                <v-icon left color="#25D366">mdi-whatsapp</v-icon>
                Whatsapp
              </span>
            </v-btn>
          </v-col>
          <!-- Instagram Button -->
          <v-col cols="4" class="d-flex justify-center p-1 pr-2">
            <v-btn class="share-btn text-none" outlined rounded large @click="shareViaInstagram">
              <span>
                <v-icon left color="#C13584">mdi-instagram</v-icon>
                Instagram
              </span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="productList.length">
          <v-col cols="12">
            <h3 class="text-center my-5 font-weight-bold">
              Productos exclusivos
            </h3>
          </v-col>
          <v-col cols="12 ml-2 mr-2">
            <product-list-microsite :products="productList" :canEditProducts="canEditProducts" />
          </v-col>
        </v-row>

        <v-row v-if="promotionalProducts.length">
          <v-col cols="12">
            <h3 class="text-center my-5 font-weight-bold">
              Productos promocionales
            </h3>
          </v-col>
          <v-col cols="12">
            <product-list-microsite :products="promotionalProducts" :sellerCode="sellerCode"
              :canEditProducts="canEditProducts" />
          </v-col>
        </v-row>
      </div>
    </div>
  </Animated>
</template>

<script>
import { Vue } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import ProductListMicrosite from './ProductListMicrosite.vue'
import axios from '@/services/base.service'
import { getMyData } from '@/services/user.service'
import { getEventDetails } from '@/services/seller.service'

export default {
  data() {
    return {
      eventId: parseInt(localStorage.getItem('selectedEvent') || '0'),
      eventName: '',
      eventSlug: '',
      canEditProducts: '',
      sellerCode: '',
      textToCopy: '',
      productList: [],
      promotionalProducts: [],
      selectedMessageIndex: 0,
      shareMessages: [
        `🎟️ ¡No te quedes afuera de este eventazo!\nConseguí tus entradas desde mi link y viví una experiencia única 🎉\n[ACA TU LINK]\n📲 ¡Sumate y compartilo con tus amigos!\n#EventoImperdible #ViviloConNosotros 🎧✨`,

        `🚨 ¡Se viene un fiestón y vos tenés que estar ahí!\n🎟️ Sacá tu entrada desde mi link: [ACA TU LINK]\n💃🕺 Nos vemos ahí 🔥`,

        `✨ Ya tengo mi entrada, ¿y vos?\n🎟️ Comprala desde mi link: [ACA TU LINK]`,

        `📅 La fiesta ya tiene fecha… y vos no te la podés perder.\n🎟️ Conseguí tu entrada desde mi link: [ACA TU LINK]\nNos vemos en la pista 💃🕺\n#NocheÉpica #NosVemosAhí ✨`,

        `🎉 ¿Plan para el finde? Ya lo tenés.\n🎶 Fiesta asegurada, buena música y la mejor vibra.\n🎟️ Sacá tu entrada por acá: [ACA TU LINK]\n👯‍♂️ ¡Invitá a tu crew y rompemos la noche! 🌟`,

        `📣 Hay una fiesta que va a dar que hablar…\nY vos podés ser parte.\n🎟️ Entradas solo por este link: [ACA TU LINK]\n🔊 Nos vemos bajo las luces. ✨\n#ModoNoche #PartyTime`,
      ],
      emailTo: '',
      loading: false,
    }
  },
  methods: {
    async loadProducts() {
      const [restricted, promotional] = await Promise.all([
        axios.get(`/events/${this.eventId}/products-restricted`),
        axios.get(`/events/${this.eventId}/products-promotional`)
      ]);

      this.productList = restricted.data.data;
      this.promotionalProducts = promotional.data.data;
    },
    async loadEventData() {
      const { data: eventData } = await getEventDetails(this.eventId, true);
      this.eventName = eventData.name;
      this.eventSlug = eventData.slug;
      this.canEditProducts = eventData.edit_products || false;
    },
    async loadUserData() {
      const { data: user } = await getMyData();
      this.sellerCode = user.code;
    },
    buildShareLink() {
      this.textToCopy = `${process.env.VUE_APP_DOMAIN_ECOMMERCE}/event/${this.eventSlug}?code=${this.sellerCode}`;
    },
    goToLink() {
      window.open(this.textToCopy, '_blank')
    },
    replaceLink(message) {
      return message.replace('[ACA TU LINK]', this.textToCopy);
    },
    copyLink() {
      const htmlContent = `<a href="${this.textToCopy}" target="_blank" style="color: #007aff; text-decoration: underline;">${this.textToCopy}</a>`;

      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlContent;
      document.body.appendChild(tempElement);

      const range = document.createRange();
      range.selectNode(tempElement);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand('copy');
        this.$toast.success('Link copiado al portapapeles');
      } catch (err) {
        this.$toast.error('No se pudo copiar el link');
      }

      document.body.removeChild(tempElement);
    },
    copyMessage() {
      const rawMessage = this.shareMessages[this.selectedMessageIndex];
      const finalMessage = this.replaceLink(rawMessage);

      const htmlFormatted = finalMessage
        .split('\n')
        .map(line => {
          if (line.includes(this.textToCopy)) {
            return `<a href="${this.textToCopy}" target="_blank" style="color: #007aff; text-decoration: underline;">${this.textToCopy}</a>`;
          }
          return line;
        })
        .join('<br>');

      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlFormatted;
      document.body.appendChild(tempElement);

      const range = document.createRange();
      range.selectNode(tempElement);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand('copy');
        this.$toast.success('Mensaje copiado al portapapeles');
      } catch (err) {
        this.$toast.error('No se pudo copiar el mensaje');
      }

      document.body.removeChild(tempElement);
    },
    shareViaWhatsApp() {
      const message = this.shareMessages[this.selectedMessageIndex]
      const link = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.replaceLink(message))}`
      window.open(link, '_blank')
    },
    shareViaInstagram() {
      const message = this.shareMessages[this.selectedMessageIndex];
      navigator.clipboard.writeText(this.replaceLink(message)).then(() => {
        this.$toast.success('Mensaje copiado. En unos segundos abriremos Instagram para que lo pegues en tu historia o DM.');
        setTimeout(() => {
          window.open('https://www.instagram.com/accounts/login/?next=/', '_blank');
        }, 2100);
      });
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.loadEventData();
      await this.loadUserData();
      this.buildShareLink();
      await this.loadProducts();
    } catch (error) {
      console.error('Error al cargar datos:', error);
      this.$toast.error('Ocurrió un error. Usando datos guardados.');
    } finally {
      this.loading = false;
    }
  },
  components: {
    SellerHeader,
    ProductListMicrosite,
  },
}
</script>

<style lang="scss" scoped>
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: black !important;
}

.v-icon.v-icon {
  font-size: 18px !important;
}

.share-btn {
  border: none;
  border-radius: 20px;
  transition: transform 0.2s ease-in-out;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
}

.share-btn span {
  color: #312726;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  font-family: inherit;
}

.titleName {
  font-size: 1.2rem;
  font-weight: 800 !important;
}

::v-deep(.v-window__prev),
::v-deep(.v-window__next) {
  background-color: #1D3557 !important;
  color: white !important;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
  z-index: 10;
  top: calc(50% - 16px);
}

::v-deep(.v-window__prev .v-icon),
::v-deep(.v-window__next .v-icon) {
  font-size: 16px !important;
}

.message-content {
  font-size: 13px;
  background-color: #EAF4FF;
}

.copy-link-btn {
  background-color: #1D3557 !important;
  color: white;
  width: 42px;
  height: 42px;
  min-width: 42px !important;
  min-height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s ease-in-out;
  padding: 0;
}

.copy-link-btn:hover {
  background-color: #133049;
}

.share-link-box {
  background-color: #EAF4FF;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1D3557;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
}

.link-text {
  word-break: break-all;
  flex: 1;
  margin-right: 12px;
  text-decoration: underline;
}

.skeleton-box {
  background: linear-gradient(90deg, #f0f0f0 25%, #eaeaea 37%, #f0f0f0 63%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite ease-in-out;
  border-radius: 5px;
}

.skeleton-subtitle {
  height: 20px;
  width: 35%;
}

.skeleton-link {
  height: 65px;
  width: 100%;
  border-radius: 10px;
}

.skeleton-message {
  height: 180px;
  width: 100%;
  border-radius: 14px;
}

.skeleton-btn {
  height: 45px;
  width: 100%;
  border-radius: 25px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>
